module.exports = __webpack_public_path__ + "img/logo.d3876f42.png";